/* global G */
import { curry, PlatformEvent } from 'lib/util'
import fetchTree from 'app/_shared/events/file/tree/fetchTree'
import session from 'app/_shared/session'

/**
 * Get Drilldown Tree Event Handler
 *
 * Fetches the given drilldown tree, using {@link fetchTree}, and wraps it in a root node before
 * returning it.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {PlatformEvent} event         information about the event that triggered this handler
 * @returns Object
 */
const getDrilldownTree = async (module, component, event) => {
  const eventBus = module[G.ADAPTER][G.EVENTS]

  try {
    const { user } = session(module)
    const userDoc = user?.ref()
    const salesOrganisations = userDoc?.value?.custom?.user?.combinations || []

    eventBus.dispatch(eventBus.type(G.LOAD, G.INIT))

    const platformEvent = new PlatformEvent(event, {
      options: {
        middleware: ({ loader, ...rest }) => Object.values(rest),
      },
    })

    const result = await fetchTree(module, component, platformEvent)

    return result?.tree?.length
      ? {
        $children: result.tree.filter(x => (x.productType === 'LM5'
          ? salesOrganisations.includes('630')
          : true)),
        type: 'Directory',
      }
      : { $children: [], type: 'Root' }
  } catch (e) {
    return { $children: [], type: 'Root' }
  } finally {
    eventBus.dispatch(eventBus.type(G.LOAD, G.DONE))
  }
}

export default curry(getDrilldownTree)
